import { filter, includes, map } from 'lodash';
import { useContext } from 'react';
import { AppContext } from '../AppContext';
import { MODULES_KEY, ROLE_KEYS } from '../common/constants';
import { getPermissionRoles, mergePermissions } from '../common/utils';

const VerifyPermissions = ({ modulekey, allowedPermissions }) => {
  const {
    state: { currentUser },
  } = useContext(AppContext);

  if (modulekey === MODULES_KEY?.APP_BUILDS) {
    if (currentUser?.tags?.includes('appbuild')) {
      return true;
    }
  }

  if (
    [
      ROLE_KEYS.USER,
      ROLE_KEYS.INTERN,
      ROLE_KEYS.TEST_TREE,
      ROLE_KEYS.MOBILE_DEVELOPER,
      ROLE_KEYS.CEO_CTO,
      ROLE_KEYS.TECH_LEAD,
      ROLE_KEYS.PROJECT_MANAGER,
    ]?.includes(currentUser?.role)
  ) {
    const roles = getPermissionRoles(currentUser);
    if (!roles?.length) {
      return false;
    }
    const mergedPermissions = mergePermissions(roles);
    const modulePermission = filter(
      mergedPermissions,
      (data) => data?.moduleName === modulekey,
    );
    if (modulePermission?.[0]?.access) {
      const permission = map(
        filter(Object?.keys(modulePermission?.[0]?.access), (data) =>
          includes(allowedPermissions, data),
        ),
        (data) => modulePermission?.[0]?.access?.[data],
      )?.every((record) => record === true);
      return permission;
    }
    return false;
  }
  return true;
};
export default VerifyPermissions;
